/* Bilingual versions of the API's validation messages for account forms. */
type LFn = (en: string, ar: string) => string;
const AR: Record<string, string> = {
  "required": "مطلوب",
  "must be at least 8 characters": "يجب أن تكون 8 أحرف على الأقل",
  "must be at most 128 characters": "يجب ألا تزيد عن 128 حرفًا",
  "must contain letters and digits": "يجب أن تحتوي على حروف وأرقام",
  "must differ from the current password": "يجب أن تختلف عن كلمة المرور الحالية",
  "incorrect password": "كلمة المرور غير صحيحة",
  "invalid or expired link": "الرابط غير صالح أو منتهي الصلاحية",
  "a valid email address is required": "أدخل بريدًا إلكترونيًا صحيحًا",
  "already registered": "مسجل مسبقًا",
  "must be 10 digits": "يجب أن يكون 10 أرقام",
  "must be 15 digits": "يجب أن يكون 15 رقمًا",
  "unknown plan": "باقة غير معروفة",
  "add a valid email address to the employee first": "أضف بريدًا إلكترونيًا صحيحًا للموظف أولًا",
};
const EN: Record<string, string> = {
  "must be at least 8 characters": "Use at least 8 characters",
  "must contain letters and digits": "Use letters and digits",
  "must differ from the current password": "Choose a password different from the current one",
  "incorrect password": "The current password is incorrect",
  "invalid or expired link": "This link is invalid or has expired",
  "a valid email address is required": "Enter a valid email address",
  "already registered": "Already registered",
};
/** Translate an API field message (falls back to the raw message). */
export function fieldMsg(L: LFn, msg: string | undefined): string | undefined {
  if (!msg) return undefined;
  const en = EN[msg] ?? msg.charAt(0).toUpperCase() + msg.slice(1);
  return L(en, AR[msg] ?? en);
}
